import { render, staticRenderFns } from "./fireFightingLegalCheck.vue?vue&type=template&id=4e8df9a8"
import script from "./fireFightingLegalCheck.vue?vue&type=script&lang=js"
export * from "./fireFightingLegalCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8df9a8')) {
      api.createRecord('4e8df9a8', component.options)
    } else {
      api.reload('4e8df9a8', component.options)
    }
    module.hot.accept("./fireFightingLegalCheck.vue?vue&type=template&id=4e8df9a8", function () {
      api.rerender('4e8df9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/legal/fireFightingLegalCheck.vue"
export default component.exports